/* eslint-disable indent */
import { FC, memo } from 'react'
import { createIcon, IconProps } from '@chakra-ui/icons'
// import { Box } from '@chakra-ui/react'

import CustomIcon from '../../CustomIcon'

interface CustomIconProps extends IconProps {
  variant?: string
  color?: string
}

const MapLyingDownWithPinIconOutline = createIcon({
  displayName: 'MapLyingDownWithPinIconOutline',
  viewBox: '0 0 24 24',
  path: (
    <>
      <g fill="none">
        <path d="M0,0h24v24h-24Z"></path>
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M16,13l0.01,-6"
        ></path>
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M17.4174,3.60456c0.776753,0.776753 0.776753,2.03612 0,2.81287c-0.776753,0.776753 -2.03612,0.776753 -2.81287,8.88178e-16c-0.776753,-0.776753 -0.776753,-2.03612 0,-2.81287c0.776753,-0.776753 2.03612,-0.776753 2.81287,-8.88178e-16"
        ></path>
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M20.522,17.568l-1.2,-6c-0.187,-0.935 -1.008,-1.608 -1.961,-1.608h-10.721c-0.953,0 -1.774,0.673 -1.961,1.608l-1.2,6c-0.248,1.238 0.699,2.392 1.961,2.392h13.12c1.262,0.001 2.209,-1.154 1.962,-2.392Z"
        ></path>
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M4.05,19.38l8.48,-4.71"
        ></path>
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M5.54,10.3l14.46,9.03"
        ></path>
      </g>
    </>
  ),
})

const MapLyingDownWithPin: FC<CustomIconProps> = (props) => {
  switch (props.variant || 'outline') {
    default:
      return <CustomIcon as={MapLyingDownWithPinIconOutline} {...props} />
  }
}

export default memo(MapLyingDownWithPin)
